module.exports = __webpack_public_path__ + "static/media/bg16.150b1c9b.jpg";